import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4dc54243"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"float":"right"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"right"} }, "Terms", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "container" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "The Pursuit of Trivia"),
  /*#__PURE__*/_createElementVNode("img", {
    class: "app",
    src: "assets/icon/pursuit.png",
    alt: "Ionic logo"
  }),
  /*#__PURE__*/_createElementVNode("h2", null, " Fun and friendly trivia questions for both single-player and multiplayer gaming "),
  /*#__PURE__*/_createElementVNode("p", { class: "marg" }, " Are you looking for a fun and engaging way to spend time with the family? Look no further! Our Trivia Quiz game is the perfect way to bring everyone together and have a blast. With single player and multiplayer modes, you can challenge each other to a battle of wits, and with in-game awards, there's something for everyone! Get your family together and give it a try TODAY! "),
  /*#__PURE__*/_createElementVNode("p", { class: "marg" }, " DOWNLOAD the best looking and the best trivia app TODAY "),
  /*#__PURE__*/_createElementVNode("p", null, "FEATURES"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, " 💯 THOUSANDS and THOUSANDS of questions and more added regularly "),
    /*#__PURE__*/_createElementVNode("li", null, " 🎨 Art and Literature 🎸 Entertainment 🌍 Geography 🕌 History👩🏽‍🔬 Science ⚽️ Sport Questions "),
    /*#__PURE__*/_createElementVNode("li", null, "👩 Play single player mode, collect points and earn awards"),
    /*#__PURE__*/_createElementVNode("li", null, " 👨🏼‍🤝‍👨🏾 Multiplayer mode, answer questions head to head against your friends and family, with customisable criteria on game mechanics "),
    /*#__PURE__*/_createElementVNode("li", null, " 🎲 Multiplayer mode to find questions when playing trivia board games "),
    /*#__PURE__*/_createElementVNode("li", null, " ⁉️ Thousands of questions you can use when playing trivia board games, with more added regularly "),
    /*#__PURE__*/_createElementVNode("li", null, "🏆 Earn awards by answering questions and earning points"),
    /*#__PURE__*/_createElementVNode("li", null, "🎉 Compete on the weekly, monthly and all time leaderboards"),
    /*#__PURE__*/_createElementVNode("li", null, "🆓 Play for FREE"),
    /*#__PURE__*/_createElementVNode("li", null, "⏰ Beat the clock in multiplayer mode")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "marg" }, " Get The Pursuit of Trivia today for FREE and enjoy exciting and challenging trivia for all ages TODAY and FOREVER "),
  /*#__PURE__*/_createElementVNode("div", { class: "buttons" }, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://play.google.com/store/apps/details?id=com.jakowicz.trivia" }, [
      /*#__PURE__*/_createElementVNode("img", {
        alt: "Get it on Google Play",
        src: "assets/icon/google-play.png",
        class: "app-badge"
      })
    ]),
    /*#__PURE__*/_createElementVNode("a", { href: "https://apps.apple.com/gb/app/the-pursuit-of-trivia/id6444321546" }, [
      /*#__PURE__*/_createElementVNode("img", {
        alt: "Get it on the App Store",
        src: "assets/icon/app-store.svg",
        class: "app-badge"
      })
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode("Mnemonic Games "),
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_router_link, { to: '/policy' }, {
                      default: _withCtx(() => [
                        _createTextVNode("Privacy")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, { collapse: "condense" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, { size: "large" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Mnemonic Games")
                    ]),
                    _: 1
                  }),
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}